// Models
import UserVerified from '../models/userVerified';

import {
    FETCH_VERIFIED_USER_REQUEST,
    FETCH_VERIFIED_USER_SUCCESS,
    FETCH_VERIFIED_USER_ERROR,
    HIDE_VERIFIED_USER_LOADER,
    SHOW_VERIFIED_USER_LOADER,
} from './userVerification.constants';

const initialState = {
    tableData: [],
    pagination: {},
    error: {},
    isLoading: false,
};

export const userVerificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_VERIFIED_USER_REQUEST:
            return {
                ...state,
                error: {},
            };
        case FETCH_VERIFIED_USER_SUCCESS: {
            const createUserData = new UserVerified(action.payload);
            return {
                ...state,
                ...createUserData,
                error: {},
                updateUser: { isSuccess: false },
            };
        }
        case SHOW_VERIFIED_USER_LOADER:
            return { ...state, isLoading: true };
        case HIDE_VERIFIED_USER_LOADER:
            return { ...state, isLoading: false };
        case FETCH_VERIFIED_USER_ERROR:
            return {
                ...initialState,
                ...action.payload,
                updateUser: { isSuccess: false },
            };
        default:
            return state;
    }
};
